export const MaatNcqTemporaryNcqId = 'NCQ<TBC>';
